import { gql } from '@apollo/client';
import { PostProject } from '../contentPage/postDetail';
import { PostSubcategory } from '../../common/helpers/domain/postCategories';
import { PropertyType } from '../../common/helpers/domain/propertyTypes';

export const MOST_POPULAR_QUERY = gql`
  query MostPopular(
    $propertyType: [String]
    $postCategory: [String]
    $popularFromDate: Int!
    $perPage: Int!
    $tag: String
  ) {
    mostPopular: mostPopularPosts(
      request: {
        propertyType: $propertyType
        postCategory: $postCategory
        popularFromDate: $popularFromDate
        perPage: $perPage
        tag: $tag
      }
    ) {
      id
      link
      title
      propertyType
      postCategory
      videoType
      featuredImage {
        url
        title
      }
      project {
        id
        name
        propertyType
        developer
        location {
          zone {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          district {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          road {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
        }
        transportations {
          value
          label
          link
        }
        priceTypes {
          starting_price
          level {
            value
            label
          }
        }
      }
    }
  }
`;

export interface MostPopularQueryRequest {
  propertyType?: PropertyType[];
  postCategory?: PostSubcategory[];
  popularFromDate: number;
  perPage: number;
  tag?: string;
}

export interface MostPopularQueryResponse {
  mostPopular: MostPopular[];
}

export interface MostPopular {
  id: number;
  title: string;
  propertyType: string[];
  postCategory: PostSubcategory;
  link: string;
  videoType: string;
  featuredImage: {
    url: string;
  };
  project: PostProject;
}
